import React from 'react';
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';
import Backdrop from '@material-ui/core/Backdrop';
import './Modal.scss';

interface ModalProps {
	open: boolean;
	close: (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => void;
	children: any;
	contentClasses?: string[];
}

const ModalElement = (props: ModalProps) => {
	const { open, close, children, contentClasses } = props;
	const baseContentClasses = ['content'];
	if (contentClasses) {
		baseContentClasses.push(...contentClasses);
	}

	return (
		<Modal
			aria-labelledby="transition-modal-title"
			aria-describedby="transition-modal-description"
			className="bubbletea-modal"
			open={open}
			onClose={close}
			closeAfterTransition
			BackdropComponent={Backdrop}
			BackdropProps={{
				timeout: 200
			}}
		>
			<Fade in={open}>
				<div className={baseContentClasses.join(' ')}>{children}</div>
			</Fade>
		</Modal>
	);
};

export default ModalElement;
